<div *ngIf="icon" class="menu-icon" #menuIcon>
  <i [innerHtml]="icon" [ngStyle]="{ color: iconColor }"></i>
</div>
<div *ngIf="label" class="label" [ngStyle]="labelStyle">{{ label }}</div>
<div #menuContent *ngIf="displayMenu" class="menu-content" [ngStyle]="menuContentStyle">
  <div #menuFrame class="menu-frame" [ngClass]="menuFrameClass">
    <div class="menu-canvas">
      <ng-content></ng-content>
    </div>
  </div>
</div>
